module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    staticClass: "map-splitter"
  }, [(_vm.isAreaDataLoaded) ? _c('div', {
    staticClass: "content"
  }, [_c('v-ons-splitter', [_c('v-ons-splitter-side', {
    staticClass: "splitter",
    attrs: {
      "width": "550px",
      "collapse": "",
      "side": "left",
      "open": _vm.isShowPanel
    }
  }, [_c('destination-panel')], 1), _vm._v(" "), _c('v-ons-splitter-content', [_c('map-index')], 1)], 1), _vm._v(" "), _c('visualization-panel'), _vm._v(" "), _c('scale-ruler')], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9af4d2cc","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/splitter.vue
// module id = 917
// module chunks = 0